import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import { DELETE_MATERIAL_TRANSPORT } from "../../../apiEndpoints";
import Modal from "../../../../../components/portal/Modal";
import ErrorDisplay from "../../../../../components/UI/ErrorDisplay";
import GradientButton from "../../../../../components/UI/buttonUI/GradientButton";
import useDelete from "../../../../../CustomHooks/useAxios/useDelete";

function MaterialDelete({ material, setConfirmDelere }) {
  const {
    executeDelete,
    isDeleting,
    isDeleteError,
    setIsDeleteError,
    deleteResult,
  } = useDelete();
  const navigate = useNavigate();

  // Disable user API call
  const handleDisableUser = () => {
    executeDelete(`${DELETE_MATERIAL_TRANSPORT}/${material.id}`);
  };

  const closeDialog = () => {
    setConfirmDelere(false);
  };

  return (
    <Modal
      onClose={isDeleting || deleteResult ? undefined : closeDialog}
      modalWidth="max-w-sm w-11/12 max-sm:w-[95%] max-md:p-4 pb-8 pt-7 px-8"
    >
      <>
        {deleteResult ? (
          <div className="text-center">
            <Check className="mx-auto" color="green" />
            <p className="pb-4">Successfully Deleted</p>
            <GradientButton
              btnText="Ok"
              width="w-26"
              onClick={() => navigate(0)}
            />
          </div>
        ) : (
          <>
            {isDeleteError && (
              <ErrorDisplay
                message={isDeleteError}
                closeAction={() => setIsDeleteError("")}
              />
            )}
            <p className="text-gray-700 mb-5">
              Are you sure you want to delete{" "}
              <span className="font-medium text-black">
                {material.material.name}
              </span>{" "}
              Transport ?{" "}
            </p>
            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <button
                onClick={closeDialog}
                className="px-4 py-2 rounded-lg border bg-dBlue-100 hover:bg-gray-200 text-dark-blue"
                disabled={isDeleting}
              >
                Cancel
              </button>
              <button
                onClick={handleDisableUser}
                className="px-4 py-2 rounded-lg text-white bg-red-600 hover:bg-red-500"
                disabled={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </>
        )}
      </>
    </Modal>
  );
}

export default MaterialDelete;
